import { render } from "./QuanLyXangDau.vue?vue&type=template&id=4f5a1464&scoped=true"
import script from "./QuanLyXangDau.vue?vue&type=script&lang=js"
export * from "./QuanLyXangDau.vue?vue&type=script&lang=js"

import "./QuanLyXangDau.vue?vue&type=style&index=0&id=4f5a1464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5a1464"]])

export default __exports__